<template>
  <div>
    <v-container class="mt-0">
      <v-row justify="center">
        <v-col cols="12" md="10">
          <v-slide-y-transition mode="out-in">
            <div class="pa-4 pt-0">
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 class="mt-0 pt-0 mb-2">
                    <div class="share-section mt-2">
                      <v-card class="pa-2" color="rgba(255,255,255,0.1)">
                        <div class="caption white--text">Share referral link:</div>
                        <v-layout align-center>
                          <v-chip color="teal" class="white--text">
                            {{ $store.state.user_info?.user_profile?.serial_no || 'N/A' }}
                          </v-chip>
                          <v-btn 
                            icon 
                            small 
                            @click="copyReferralLink" 
                            class="ml-2 copy-btn" 
                            color="teal"
                            :class="{ 'copy-clicked': copyAnimation }"
                          >
                            <i style="color: white;" class="fas fa-copy"></i>
                          </v-btn>
                          <v-btn icon small @click="shareViaWhatsApp" class="ml-1" color="green">
                            <i style="color: white;" class="fab fa-whatsapp"></i>
                          </v-btn>
                          <v-btn icon small @click="shareViaFacebook" class="ml-1" color="blue">
                            <i style="color: white;" class="fab fa-facebook"></i>
                          </v-btn>
                        </v-layout>
                      </v-card>
                    </div>

                    <v-card v-if="debugInfo" class="mb-4 elevation-2" color="grey lighten-4">
                      <v-card-title class="subtitle-2">Calculation Logic:</v-card-title>
                      <v-card-text class="caption">
                        <div>Marketer saved amount: {{ debugInfo.marketer_saved_amount }}</div>
                        <div>Clients taken count: {{ debugInfo.clients_taken_count }}</div>
                        <div>Total eligible clients: {{ debugInfo.total_eligible_clients }}</div>

                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-divider class="my-4"></v-divider>

              <div class="elevation-4 primary white--text font-weight-bold subheading py-2 text-xs-center">
                Active ({{ clientsHigh.length }} clients)
              </div>
              <v-card class="mb-4 elevation-2" color="white">
                <v-divider></v-divider>
                <v-card-text>
                  <v-divider class="my-3"></v-divider>
                  <div v-if="clientsHigh.length === 0" class="text-center grey--text">
                    No active clients at the moment
                  </div>
                  <div
                    v-for="(client, index) in clientsHigh"
                    :key="index"
                    class="client-item"
                  >
                    <v-layout align-center justify-space-between>
                      <div class="text-xl font-weight-medium">
                        {{ client.username }}
                        <div class="caption grey--text">
                          <span v-if="client.status_take">Status: Awaiting confirmation</span>
                          <span v-else>Status: Save confirmed</span>
                        </div>
                      </div>
                      <v-chip 
                        small 
                        :color="client.status_take ? 'orange' : 'green'"
                        :text-color="client.status_take ? 'black' : 'white'"
                      >
                        <v-icon left small>
                          {{ client.status_take ? 'mdi-clock' : 'mdi-check' }}
                        </v-icon>
                        {{ client.status_take ? 'Pending' : 'Taken' }}
                      </v-chip>
                    </v-layout>
                    <v-divider class="my-3"></v-divider>
                  </div>
                </v-card-text>
              </v-card>

              <v-divider class="my-4"></v-divider>

              <div class="elevation-4 red white--text font-weight-bold subheading py-2 text-xs-center">
                Inactive ({{ clientsLow.length }} clients)
              </div>
              <v-card class="elevation-2" color="white">
                <v-divider></v-divider>
                <v-card-text>
                  <div v-if="clientsLow.length === 0" class="text-center grey--text">
                    All your clients are active! 🎉
                  </div>
                  <div
                    v-for="(client, index) in clientsLow"
                    :key="index"
                    class="client-item"
                  >
                    <v-layout align-center justify-space-between>
                      <div class="text-xl font-weight-medium">
                        {{ client.username }}
                      </div>
                      <v-chip small color="grey" text-color="white">
                        <v-icon left small>mdi-account-off</v-icon>
                        Inactive
                      </v-chip>
                    </v-layout>
                    <v-divider v-if="index < clientsLow.length - 1" class="my-3"></v-divider>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-slide-y-transition>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import 'animate.css'

export default {
  data() {
    return {
      clientsHigh: [],
      clientsLow: [],
      message: '',
      serialNo: '',
      debugInfo: null, // For displaying calculation info
      copyAnimation: false, // For copy button animation
    }
  },

  async mounted() {
    document.title = "PettyCash | Clients"
    this.$store.commit('setCloseURL', "/")
    await this.loadClientsData()
    await this.getSerialNo()
  },

  methods: {
    async loadClientsData() {
      try {
        const response = await axios.get('/api/v1/home/list_marketer_clients/', {
          headers: {
            'Authorization': `Token ${this.$store.state.token}`
          }
        })
        
        this.clientsHigh = response.data.clients_high
        this.clientsLow = response.data.clients_low
        this.message = response.data.message
        this.debugInfo = response.data.debug_info // Debug information
        
        console.log('Client data loaded:', {
          clientsHigh: this.clientsHigh,
          clientsLow: this.clientsLow,
          debugInfo: this.debugInfo
        })
        
      } catch (error) {
        console.error('Error loading clients:', error)
        this.$store.dispatch('showSnackbar', {
          color: 'error',
          text: 'Error loading data'
        })
      }
    },

    generateReferralLink() {
      const baseUrl = "https://myapp.pettycashglobal.com"
      const serialNo = this.serialNo
      return `${baseUrl}/signup?referral=${encodeURIComponent(serialNo)}`
    },


  copyReferralLink() {
  const link = this.generateReferralLink();

  // Fallback simple et compatible
  const textArea = document.createElement("textarea");
  textArea.value = link;
  textArea.style.position = "fixed"; // évite le scroll
  textArea.style.top = "-1000px";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const success = document.execCommand('copy');
    this.$store.commit('setSnackBarMessage', success ? 'Lien copié avec succès ! 📋' : 'Échec de la copie.')
    this.$store.commit('setSnackBarColor', success ? 'success' : 'error')
    this.$store.commit('activateSnackBar', true)
    
    this.$store.dispatch('showSnackbar', {
      color: success ? 'success' : 'error',
      text: success ? 'Lien copié avec succès ! 📋' : 'Échec de la copie.'
    });
  } catch (err) {
    this.$store.dispatch('showSnackbar', {
      color: 'error',
      text: "Erreur lors de la copie 😞"
    });
  }

  document.body.removeChild(textArea);
},
    shareViaWhatsApp() {
      const link = this.generateReferralLink()
      const message = `Join PettyCash with my referral code: ${link}`
      window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank')
    },

    shareViaFacebook() {
      const link = this.generateReferralLink()
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`,
        '_blank',
        'width=600,height=400'
      )
    },

    async getSerialNo() {
      try {
        const response = await axios.get('/api/v1/home/get_serial_no/', {
          headers: {
            'Authorization': `Token ${this.$store.state.token}`
          }
        })
        console.log("Serial retrieved:", response.data.code)
        this.serialNo = response.data.code
      } catch (error) {
        console.error("Error retrieving serial_no", error.response?.data)
      }
    },

    // Method to refresh data
    async refreshData() {
      await this.loadClientsData()
    }
  },
}
</script>

<style scoped>
.client-item {
  padding: 8px 0;
  transition: background-color 0.2s;
}

.client-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 4px;
  padding: 8px 12px;
}

.outine-2 {
  border: 2px solid white;
}

@media (max-width: 499px) {
  .saving_heading {
    font-size: 12px;
  }
}

.card--flex-toolbar {
  margin-top: -124px;
}

.learn-more-btn {
  text-transform: initial;
  text-decoration: underline;
}

.welcome-message {
  font-size: 16px; /* ou plus petit, comme 14px selon ce que tu veux */
}

@media (max-width: 499px) {
  .welcome-message {
    font-size: 12px;
  }
}

.toolbar-title-top {
  margin-top: -30px; /* Ajuste selon le rendu */
}

@media (max-width: 600px) {
  .toolbar-title-top {
    margin-top: -60px;
  }
}

.summary-card {
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.primary-bg {
  background:#00479b;
  color: white;
}

.secondary-bg {
  background: #424242;
  color: white;
}

.success-bg {
  background: #4CAF50;
}

.warning-bg {
  background: #FF9800;
}

.summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.affiliate-count {
  font-size: 1.5em;
  background: rgba(255, 255, 255, 0.1);
  padding: 6px 12px;
  border-radius: 4px;
  margin-top: 0; /* Suppression de la marge supérieure */
}

.balance-container {
  font-size: 1.5em;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0; /* Espacement entre les éléments à 0 */
  padding: 12px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin-top: 10px; /* Réduction de la marge supérieure */
}

.totalcommissions {
  font-size: 1em;
  padding: 6px 12px;
  border-radius: 4px;
  margin-top: 0; 
}
@media (max-width: 600px) {
  .affiliate-count {
    font-size: 0.8em;
    padding: 4px 8px;
  }
  
  .balance-container {
    padding: 8px;
    margin-top: 8px; /* Réduction supplémentaire sur mobile */
  }
}

.share-section {
  max-width: 200px;
  margin-top: 5px;
  background-color: #00479b;
}

.share-section .v-chip {
  height: 32px;
  font-size: 0.9rem;
}

.share-section .v-btn {
  transition: transform 0.2s;
}

.share-section .v-btn:hover {
  transform: scale(1.1);
}

.fab {
  font-size: 1.3rem;
}

/* Animations pour les valeurs qui changent */
.balance-label, .affiliate-count, .total-commissions {
  transition: all 0.3s ease-in-out;
  min-width: 120px; /* Empêche le changement de largeur brutal */
  padding: 4px 8px;
  border-radius: 4px;
}

/* Animation quand les valeurs augmentent */
@keyframes valueIncrease {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.value-update {
  animation: valueIncrease 0.5s ease-out;
  background-color: rgba(76, 175, 80, 0.1); /* Fond vert léger */
  color: #4CAF50; /* Texte vert */
}

/* Adaptation responsive automatique */
.balance-container {
  display: inline-flex;
  flex-wrap: wrap;
  background: rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

/* Effet hover pour les cartes */
.v-card {
  transition: transform 0.2s, box-shadow 0.2s;
}

.v-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

/* Adaptation automatique de la taille de police */
.balance-label b, .affiliate-count b {
  font-size: clamp(1rem, 2vw, 1.2rem);
  display: inline-block;
  min-width: 80px; /* Maintient l'espace pour les chiffres */
}


/* Animation pour le bouton de copie */
.fa-copy {
  transition: transform 0.2s;
}

.v-btn:hover .fa-copy {
  transform: scale(1.1) rotate(-5deg);
}


/* Copy button animation */
.copy-btn {
  transition: all 0.2s ease;
}

.copy-btn:hover .fa-copy {
  transform: scale(1.1) rotate(-5deg);
}

.copy-clicked {
  animation: copySuccess 0.6s ease;
}

@keyframes copySuccess {
  0% { transform: scale(1); }
  25% { transform: scale(1.2) rotate(10deg); background-color: rgba(76, 175, 80, 0.3); }
  50% { transform: scale(1.1) rotate(-5deg); }
  75% { transform: scale(1.05); }
  100% { transform: scale(1); }
}


/* Progressif apparition des éléments */
.v-flex {
  opacity: 0;
  animation: fadeInUp 0.5s ease forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Adaptation automatique du layout */
.share-section {
  max-width: max-content; /* S'adapte au contenu */
  margin: 8px auto;
  padding: 8px;
  border-radius: 8px;
  background: linear-gradient(45deg, #00479b, #0066cc);
}

.commission-container {
  display: inline-flex;
  min-width: min-content;
}

.commission-label {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: baseline;
  line-height: 1.4;
}

.label-text {
  white-space: nowrap;
}

.value {
  flex: 1;
  min-width: max-content;
}

/* Version responsive */
@media (max-width: 600px) {
  .commission-label {
    flex-direction: column;
    gap: 0.2rem;
  }
}
</style>